import BlogList from "../../Components/Blog/BlogList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import Pagebanner from "../../layout/Banner";
import { Helmet } from "react-helmet";

const Blogs = ()=>{
    return(
        <>
        
         <Helmet>
        <title>Blogs</title>
        <meta
          name="description"
          content="ADV Akash Giri l Chambers: Expert legal solutions, trusted lawyers, and decades of excellence in serving clients. Explore our services and success stories."
        />
        <meta
          name="keywords"
          content="ADV Akash Giri l, Law Firm, Lawyers, Legal Services, Legal Expertise, Justice"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet> 
        <Header/>
        <Pagebanner title={"Legal Library"} subtitle={"Latest Legal Insights"}/>
        <BlogList/>
        <Footer/>   
        </>
    )
}
export default Blogs;